import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'sp-table-body-row-form',
  standalone: false,
  templateUrl: './table-body-row-form.component.html',
  styleUrls: ['./table-body-row-form.component.scss']

})
export class TableBodyRowFormComponent {
  @Input() row = null;
  @Input() sendData = null;
  @Input() form = null;
  @Input() cells = null;
  @Input() formGroup = new UntypedFormGroup({});
  @Input() DataService = {
    create: (row, formGroup, method) => {},
    fetch: () => {},
    update: (row, id, formGroup, method) => {},
    delete: id => {}
  };
  @Input() cancelTableForm = (row?) => {};

  constructor() {}
}